function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Google:_Icon_-_Yellow",
  "data-name": "Google: Icon - Yellow",
  d: "M22.284,10.591H12.5v4.057h5.632c-.525,2.577-2.72,4.057-5.632,4.057A6.2,6.2,0,0,1,12.5,6.3,6.07,6.07,0,0,1,16.366,7.68L19.42,4.625A10.493,10.493,0,1,0,12.5,23c5.25,0,10.023-3.818,10.023-10.5A8.711,8.711,0,0,0,22.284,10.591Z",
  transform: "translate(-2 -2)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Google:_Icon",
  "data-name": "Google: Icon",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Google:_Icon_-_Yellow-2",
  "data-name": "Google: Icon - Yellow",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Google:_Icon_-_Yellow-3",
  "data-name": "Google: Icon - Yellow",
  d: "M0,23.409V11l8.114,6.2Z",
  transform: "translate(-0.955 -6.705)",
  fill: "#fbbc05"
})), /*#__PURE__*/React.createElement("g", {
  id: "Google:_Icon_-_Red-2",
  "data-name": "Google: Icon - Red",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Google:_Icon_-_Red-3",
  "data-name": "Google: Icon - Red",
  d: "M0,5.25l8.114,6.2,3.341-2.911L22.909,6.682V0H0Z",
  transform: "translate(-0.955 -0.955)",
  fill: "#ea4335"
})), /*#__PURE__*/React.createElement("g", {
  id: "Google:_Icon_-_Green-2",
  "data-name": "Google: Icon - Green",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Google:_Icon_-_Green-3",
  "data-name": "Google: Icon - Green",
  d: "M0,17.659,14.318,6.682l3.77.477L22.909,0V22.909H0Z",
  transform: "translate(-0.955 -0.955)",
  fill: "#34a853"
})), /*#__PURE__*/React.createElement("g", {
  id: "Google:_Icon_-_Blue-2",
  "data-name": "Google: Icon - Blue",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Google:_Icon_-_Blue-3",
  "data-name": "Google: Icon - Blue",
  d: "M29.7,28.659,14.909,17.2,13,15.773,29.7,11Z",
  transform: "translate(-7.75 -6.705)",
  fill: "#4285f4"
})));

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.523,
    height: 21,
    viewBox: "0 0 20.523 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.bbcad256.svg";
export { ForwardRef as ReactComponent };